<template>
    <div class="t3m-Dropdown"
         ref="dropdown">
        <h3 ref="toggle"
            class="flex items-center mb-0 space-x-2 font-normal cursor-pointer h4 group t3m-Dropdown-toggle"
            id="dropdownToggle"
            aria-haspopup="true"
            :aria-expanded="show">
            <span>
                <slot name="dropdown-title"></slot>
            </span>
            <span class="inline-block p-0.5 text-white rounded-full cursor-pointer bg-primary group-hover:bg-primary-hover"
                  :class="{
                      '-rotate-90': show
                  }">
                <span class="sr-only">
                    Show subnavigation
                </span>
                <svg xmlns="http://www.w3.org/2000/svg"
                     class="w-3 h-3"
                     viewBox="0 0 448 512"
                     fill="currentColor">
                    <path
                          d="M432.6 209.3l-191.1 183.1C235.1 397.8 229.1 400 224 400s-11.97-2.219-16.59-6.688L15.41 209.3C5.814 200.2 5.502 184.1 14.69 175.4c9.125-9.625 24.38-9.938 33.91-.7187L224 342.8l175.4-168c9.5-9.219 24.78-8.906 33.91 .7187C442.5 184.1 442.2 200.2 432.6 209.3z" />
                </svg>
            </span>
        </h3>

        <div class="hidden">
            <div ref="menu"
                 class="flex flex-col overflow-y-auto t3m-Dropdown-menu max-h-screen-height-2/5 overscroll-contain"
                 aria-labelledby="dropdownToggle">
                <slot name="dropdown-menu"> </slot>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    name: "Dropdown",
    data() {
        return {
            show: false,
        };
    },
    mounted() {
        const vm = this;
        const { dropdown, toggle, menu } = this.$refs;

        if (window.tippy) {
            window.tippy(toggle, {
                content: menu,
                allowHTML: true,
                trigger: 'click',
                placement: 'auto',
                interactive: true,
                theme: 'light',
                onCreate() {
                    dropdown.classList.add('t3m-Dropdown--initialized');
                },
                onShow() {
                    vm.show = true;
                },
                onHide() {
                    vm.show = false;
                }
            });
        }
    },
    methods: {
        toggleMenu: function () {
            this.show = !this.show;
        },
        hideMenu: function () {
            this.show = false;
        },
    },
};
</script>
